import React, { useState } from 'react';
import { Button } from '../shared';

export interface WelcomeScreenProps {
  onEnable: () => void;
  onSkip: () => void;
}

/**
 * First-load screen: lets the user opt into the optional app lock or skip.
 * Data always stays on this device; the lock only adds a password gate.
 */
export function WelcomeScreen({ onEnable, onSkip }: WelcomeScreenProps): React.ReactElement {
  const [busy, setBusy] = useState(false);

  const handleEnable = () => {
    setBusy(true);
    onEnable();
  };

  return (
    <div className="applock-screen" role="main">
      <div className="applock-card">
        <div className="applock-card__icon" aria-hidden="true">
          &#128274;
        </div>
        <h1 className="applock-card__title">Protect your data</h1>
        <p className="applock-card__text">
          Add an optional app lock — a password gate that keeps others out of your absence
          calculations. Your data stays on this device either way.
        </p>

        <div className="applock-card__actions">
          <Button variant="primary" size="md" loading={busy} onClick={handleEnable}>
            Enable App Lock
          </Button>
          <Button variant="ghost" size="md" onClick={onSkip}>
            Skip for now
          </Button>
        </div>
        <p className="applock-card__hint">You can enable this later from the header.</p>
      </div>
    </div>
  );
}
